{
    "name": "pullback",
    "actionTrace": [
        {
            "type": "move",
            "performerKey": "princess",
            "position": {
                "x": 23,
                "y": 16,
                "z": 1
            },
            "performerPosition": {
                "x": 23,
                "y": 16,
                "z": 1
            },
            "distance": 1
        },
        {
            "type": "invoke skill",
            "skillKey": "pull",
            "performerKey": "friend",
            "position": {
                "x": 23,
                "y": 16,
                "z": 1
            },
            "performerPosition": {
                "x": 23,
                "y": 14,
                "z": 1
            }
        }
    ],
    "deltastageSum": {
        "units": {
            "princess": {
                "key": "princess",
                "jobKey": "sword",
                "affiliation": "good",
                "isRecruited": true,
                "maxhealth": 50,
                "moverange": 2,
                "skills": [
                    "inflict-damage",
                    "rally",
                    "recruit"
                ],
                "name": "PRINCESS",
                "faceKey": "human",
                "bodyKey": "good",
                "dialogue": {
                    "death": "Damn."
                },
                "portraits": {
                    "neutral": "./RP-neutral2-ZK5JV6ZJ.png",
                    "angry": "./RP-angry-AJ6PJQEY.png",
                    "happy": "./RP-happy-HEYINXAH.png"
                },
                "position": {
                    "mode": "absolute",
                    "x": 23,
                    "y": 15,
                    "z": 1
                },
                "spawnspot": {
                    "key": "ANgDsaMKeO8wm1cjN4l9Y",
                    "position": {
                        "x": 24,
                        "y": 16,
                        "z": 1
                    },
                    "tag": "player-spawn"
                },
                "energy": {
                    "energy": {
                        "move": false
                    }
                }
            },
            "hero": {
                "key": "hero",
                "jobKey": "hammer",
                "aliases": [
                    "Himmel",
                    "paladin",
                    "Masked Man"
                ],
                "affiliation": "good",
                "isRecruited": true,
                "maxhealth": 50,
                "skills": [
                    "inflict-damage",
                    "smite",
                    "recruit"
                ],
                "name": "HERO",
                "faceKey": "human",
                "bodyKey": "good",
                "dialogue": {
                    "death": "Damn."
                },
                "position": {
                    "mode": "absolute",
                    "x": 24,
                    "y": 14,
                    "z": 1
                },
                "spawnspot": {
                    "key": "EypXwXcytzm3OHIvMV0Cp",
                    "position": {
                        "x": 24,
                        "y": 14,
                        "z": 1
                    },
                    "tag": "player-spawn"
                }
            },
            "friend": {
                "key": "friend",
                "jobKey": "bow",
                "affiliation": "good",
                "isRecruited": true,
                "maxhealth": 40,
                "skills": [
                    "inflict-damage",
                    "pull",
                    "recruit"
                ],
                "name": "FRIEND",
                "faceKey": "human",
                "bodyKey": "good",
                "dialogue": {
                    "death": "Damn."
                },
                "position": {
                    "mode": "absolute",
                    "x": 23,
                    "y": 14,
                    "z": 1
                },
                "spawnspot": {
                    "key": "caaQtHrMJGXdtc600Tg_h",
                    "position": {
                        "x": 24,
                        "y": 15,
                        "z": 1
                    },
                    "tag": "player-spawn"
                },
                "experience": 10,
                "energy": {
                    "key": "friend",
                    "energy": {
                        "move": false,
                        "invoke skill": false
                    }
                }
            }
        },
        "audio": {
            "triggerKey": "Unit:Pull"
        },
        "intent": {
            "type": "reposition",
            "positions": [
                {
                    "x": 23,
                    "y": 16,
                    "z": 1
                },
                {
                    "x": 23,
                    "y": 15,
                    "z": 1
                }
            ]
        }
    },
    "chapterSlug": "g1",
    "player": {
        "affiliation": "good",
        "inventory": {
            "gold": 0
        },
        "party": {
            "units": {
                "princess": {
                    "key": "princess",
                    "jobKey": "sword",
                    "affiliation": "good",
                    "isRecruited": true,
                    "maxhealth": 50,
                    "moverange": 2,
                    "skills": [
                        "inflict-damage",
                        "rally",
                        "recruit"
                    ],
                    "name": "PRINCESS",
                    "faceKey": "human",
                    "bodyKey": "good",
                    "dialogue": {
                        "death": "Damn."
                    },
                    "portraits": {
                        "neutral": "./RP-neutral2-ZK5JV6ZJ.png",
                        "angry": "./RP-angry-AJ6PJQEY.png",
                        "happy": "./RP-happy-HEYINXAH.png"
                    }
                },
                "hero": {
                    "key": "hero",
                    "jobKey": "hammer",
                    "aliases": [
                        "Himmel",
                        "paladin",
                        "Masked Man"
                    ],
                    "affiliation": "good",
                    "isRecruited": true,
                    "maxhealth": 50,
                    "skills": [
                        "inflict-damage",
                        "smite",
                        "recruit"
                    ],
                    "name": "HERO",
                    "faceKey": "human",
                    "bodyKey": "good",
                    "dialogue": {
                        "death": "Damn."
                    }
                },
                "friend": {
                    "key": "friend",
                    "jobKey": "bow",
                    "affiliation": "good",
                    "isRecruited": true,
                    "maxhealth": 40,
                    "skills": [
                        "inflict-damage",
                        "pull",
                        "recruit"
                    ],
                    "name": "FRIEND",
                    "faceKey": "human",
                    "bodyKey": "good",
                    "dialogue": {
                        "death": "Damn."
                    }
                },
                "aide": {
                    "key": "aide",
                    "jobKey": "dagger",
                    "affiliation": "good",
                    "isRecruited": true,
                    "maxhealth": 40,
                    "skills": [
                        "inflict-damage",
                        "swap",
                        "recruit"
                    ],
                    "name": "AIDE",
                    "faceKey": "human",
                    "bodyKey": "good",
                    "dialogue": {
                        "death": "Damn."
                    }
                }
            }
        }
    },
    "gameSlug": "war",
    "randomSeed": "rHG4qOYI2GGzsdAMR80pF",
    "captureDate": 1736382743732,
    "data": {}
}
